import React, { useState } from 'react';
import './FiltersModal.css';

function FiltersModal({ isOpen, onClose, onApplyFilters, currentFilters }) {
  const [filters, setFilters] = useState({
    amenities: currentFilters?.amenities || [],
    placeType: currentFilters?.placeType || 'any',
    minPrice: currentFilters?.minPrice || 0,
    maxPrice: currentFilters?.maxPrice || 5000,
    bedrooms: currentFilters?.bedrooms || 'any',
    bathrooms: currentFilters?.bathrooms || 'any',
    ...currentFilters
  });

  const amenitiesList = [
    { id: 'parking', label: 'Free parking', emoji: '🅿️' },
    { id: 'cancellation', label: 'Free cancellation', emoji: '📅' },
    { id: 'washer', label: 'Washer', emoji: '🧺' },
    { id: 'pets', label: 'Allows pets', emoji: '🐾' }
  ];

  const handleAmenityToggle = (amenityId) => {
    setFilters({
      ...filters,
      amenities: filters.amenities.includes(amenityId)
        ? filters.amenities.filter(a => a !== amenityId)
        : [...filters.amenities, amenityId]
    });
  };

  const handlePriceChange = (type, value) => {
    setFilters({ ...filters, [type]: value });
  };

  const handleClearAll = () => {
    setFilters({
      amenities: [],
      placeType: 'any',
      minPrice: 0,
      maxPrice: 5000,
      bedrooms: 'any',
      bathrooms: 'any'
    });
  };

  const handleApply = () => {
    onApplyFilters(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="filters-modal-overlay" onClick={onClose}>
      <div className="filters-modal" onClick={(e) => e.stopPropagation()}>
        <div className="filters-modal-header">
          <h2>Filters</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="filters-modal-content">
          {/* Recommended amenities */}
          <div className="filter-section">
            <h3>Recommended for you</h3>
            <div className="amenities-grid">
              {amenitiesList.map(amenity => (
                <button
                  key={amenity.id}
                  className={`amenity-card ${filters.amenities.includes(amenity.id) ? 'active' : ''}`}
                  onClick={() => handleAmenityToggle(amenity.id)}
                >
                  <span className="amenity-emoji">{amenity.emoji}</span>
                  <span className="amenity-label">{amenity.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Type of place */}
          <div className="filter-section">
            <h3>Type of place</h3>
            <div className="place-type-buttons">
              {['any', 'room', 'entire'].map(type => (
                <button
                  key={type}
                  className={`place-type-btn ${filters.placeType === type ? 'active' : ''}`}
                  onClick={() => setFilters({ ...filters, placeType: type })}
                >
                  {type === 'any' && 'Any type'}
                  {type === 'room' && 'Room'}
                  {type === 'entire' && 'Entire home'}
                </button>
              ))}
            </div>
          </div>

          {/* Price range */}
          <div className="filter-section">
            <h3>Price range</h3>
            <p className="price-note">Trip price, includes all fees</p>
            
            <div className="price-inputs">
              <div className="price-input-group">
                <label>Minimum</label>
                <input
                  type="number"
                  value={filters.minPrice}
                  onChange={(e) => handlePriceChange('minPrice', parseInt(e.target.value))}
                  min="0"
                />
              </div>
              <div className="price-input-group">
                <label>Maximum</label>
                <input
                  type="number"
                  value={filters.maxPrice}
                  onChange={(e) => handlePriceChange('maxPrice', parseInt(e.target.value))}
                  min="0"
                />
              </div>
            </div>

            <div className="price-slider-container">
              <input
                type="range"
                min="0"
                max="5000"
                value={filters.minPrice}
                onChange={(e) => handlePriceChange('minPrice', parseInt(e.target.value))}
                className="price-slider min-slider"
              />
              <input
                type="range"
                min="0"
                max="5000"
                value={filters.maxPrice}
                onChange={(e) => handlePriceChange('maxPrice', parseInt(e.target.value))}
                className="price-slider max-slider"
              />
            </div>
          </div>

          {/* Bedrooms */}
          <div className="filter-section">
            <h3>Rooms and beds</h3>
            <div className="rooms-selector">
              <label>Bedrooms</label>
              <div className="room-buttons">
                {['any', '1', '2', '3', '4+'].map(count => (
                  <button
                    key={count}
                    className={`room-btn ${filters.bedrooms === count ? 'active' : ''}`}
                    onClick={() => setFilters({ ...filters, bedrooms: count })}
                  >
                    {count === 'any' ? 'Any' : count}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="filters-modal-footer">
          <button className="clear-btn" onClick={handleClearAll}>Clear all</button>
          <button className="apply-btn" onClick={handleApply}>Show results</button>
        </div>
      </div>
    </div>
  );
}

export default FiltersModal;
